import { motion } from 'framer-motion';
import { Car, Bike, Ship, Caravan, HelpCircle, Wallet } from 'lucide-react';
import { Label } from '../../components/ui/label';

const vehicleTypes = [
  { value: 'car', label: 'Car', icon: Car },
  { value: 'motorbike', label: 'Motorbike', icon: Bike },
  { value: 'boat', label: 'Boat', icon: Ship },
  { value: 'caravan', label: 'Caravan', icon: Caravan },
  { value: 'other', label: 'Other', icon: HelpCircle }
];

const StepLoanType = ({ formData, handleChange }) => {
  return (
    <div className="space-y-6">
      <div className="text-center mb-8">
        <h2 className="font-outfit text-2xl md:text-3xl font-bold text-black mb-2">
          What type of loan do you need?
        </h2>
        <p className="text-gray-600">Select the option that best fits your needs</p>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <button
          onClick={() => handleChange('loan_type', 'vehicle')}
          data-testid="loan-type-vehicle"
          className={`p-6 rounded-xl border-2 transition-all ${
            formData.loan_type === 'vehicle'
              ? 'border-[#00D47E] bg-[#00D47E]/5'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <Car className={`w-12 h-12 mx-auto mb-3 ${formData.loan_type === 'vehicle' ? 'text-[#00D47E]' : 'text-gray-400'}`} />
          <p className="font-semibold text-black">Vehicle Loan</p>
          <p className="text-xs text-gray-500 mt-1">Cars, bikes, boats & more</p>
        </button>

        <button
          onClick={() => { handleChange('loan_type', 'personal'); handleChange('vehicle_category', ''); }}
          data-testid="loan-type-personal"
          className={`p-6 rounded-xl border-2 transition-all ${
            formData.loan_type === 'personal'
              ? 'border-[#00D47E] bg-[#00D47E]/5'
              : 'border-gray-200 hover:border-gray-300'
          }`}
        >
          <Wallet className={`w-12 h-12 mx-auto mb-3 ${formData.loan_type === 'personal' ? 'text-[#00D47E]' : 'text-gray-400'}`} />
          <p className="font-semibold text-black">Personal Loan</p>
          <p className="text-xs text-gray-500 mt-1">For any purpose</p>
        </button>
      </div>

      {/* Vehicle Type Selector */}
      {formData.loan_type === 'vehicle' && (
        <motion.div
          initial={{ opacity: 0, y: 10 }}
          animate={{ opacity: 1, y: 0 }}
          className="pt-4 border-t border-gray-100"
        >
          <Label className="text-gray-700 mb-3 block">What type of vehicle?</Label>
          <div className="grid grid-cols-3 sm:grid-cols-5 gap-2">
            {vehicleTypes.map(({ value, label, icon: Icon }) => (
              <button
                key={value}
                onClick={() => handleChange('vehicle_category', value)}
                data-testid={`vehicle-type-${value}`}
                className={`p-3 rounded-lg border-2 transition-all flex flex-col items-center ${
                  formData.vehicle_category === value
                    ? 'border-[#00D47E] bg-[#00D47E]/5'
                    : 'border-gray-200 hover:border-gray-300'
                }`}
              >
                <Icon className={`w-6 h-6 mb-1 ${formData.vehicle_category === value ? 'text-[#00D47E]' : 'text-gray-400'}`} />
                <span className="text-xs font-medium">{label}</span>
              </button>
            ))}
          </div>
        </motion.div>
      )}
    </div>
  );
};

export default StepLoanType;
